import React, { useEffect, useState } from "react";
import { Input } from "../../components/Form";
import toast from "react-hot-toast";
import useButtonLoader from "../../hooks/UseButtonLoader";
import { UpdateSettingApi, getSettingApi } from "../../services/setting";

const SettingManagement = () => {
  const [inputValue, setInputValue] = useState({
    subscriptionValue: "",
  });
  const [error, setError] = useState({});
  const [buttonref, buttonLoader] = useButtonLoader("Update");
  const handleValidation = () => {
    let errorMessage = {};
    let status = true;
    if (!inputValue.subscriptionValue) {
      errorMessage["subscriptionValue"] = "Please enter Amount";
      status = false;
    }
    setError(errorMessage);
    return status;
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value });
  };
  const SettingHandler = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      try {
        buttonLoader(true);
        const res = await UpdateSettingApi(inputValue);
        if (res?.data?.status === 200) {
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
        }
      } catch (error) {
        toast.error(error?.message);
      } finally {
        buttonLoader(false);
      }
    }
  };

  const getSettingData = async () => {
    try {
      //   showLoader();
      const res = await getSettingApi();
      if (res.data?.status === 200) {
        console.log(res?.data?.data);
        setInputValue({
          subscriptionValue: res?.data?.data?.data?.subscriptionValue || "",
        });

        // hideLoader();
      }
    } catch (err) {
      toast.error(err?.message);
    }
  };

  useEffect(() => {
    getSettingData();
  }, []);

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">Update Setting</h4>
        </div>

        <div className="row">
          <form
            // onSubmit={SettingHandler}
            className="col-md-10 mx-auto my-3"
          >
            <div className="CommonForm">
              <div className="form-group col-6">
                <Input
                  type={"text"}
                  name="subscriptionValue"
                  value={inputValue?.subscriptionValue}
                  onChange={onChangeHandler}
                  placeholder="Enter Percentage"
                  className={`form-control password `}
                  label={"Subscription Percentage"}
                  error={error.subscriptionValue}
                  required
                />
              </div>
              <div className=" ">
                <button
                  ref={buttonref}
                  type="submit"
                  className="btn_size"
                  onClick={SettingHandler}
                >
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SettingManagement;
